import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlpInvestigationC = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17783" data-mp="193vwghvzksr8">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17784" data-mp="1hytsvyycennb"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17785" data-mp="1mxde1x543vem">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17786" data-mp="1mzhhkdz3msed">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17787" data-mp="1rvetm83bxclc">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17788" data-mp="1wtq8ix8hedaf">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17789" data-mp="2jcpy9td8g74">
          <div className="text-left" data-id="element-17790" data-mp="9o90dx4xw6vw">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17791" data-mp="9psfvlirudwm">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17792" data-mp="sl0r2rmt9o9z">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17793" data-mp="inw3cndbhkr2">
        <div className="max-w-4xl mx-auto" data-id="element-17794" data-mp="dq2xjvfxesrb">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17795" data-mp="dp1d50d0stwx">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-17796" data-mp="2yfsbm68t2aiy">
            GLP-1 DEPRESSION: REAL SIDE EFFECT OR COINCIDENCE?
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17797" data-mp="1uhy3fg74n8k5">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17798" data-mp="1ufvdew5z5fff">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17799" data-mp="1lhji4gu5xtgn" />
            </div>
            <div className="flex-1" data-id="element-17800" data-mp="16qspx7onssd0">
              <div className="flex items-center" data-id="element-17801" data-mp="1bjlv1wo1i2pm">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17802" data-mp="1bl6mveiyz7js">
                  By Dr. Tom Parham, MD, FACE
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17803" data-mp="12qiirrp4rvwk">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17804" data-mp="ntrg99k5u42q" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17805" data-mp="nv2mrh4zppxj">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17806" data-mp="ss2oxgypy8jd">
                Board-Certified Endocrinologist, 30 Years Clinical Practice
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17807" data-mp="568ueis46k5k">
                <div className="flex items-center mr-4" data-id="element-17808" data-mp="j58kluv9z73u">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17809" data-mp="j6tctdu4adyj" />
                  <span data-id="element-17810" data-mp="e5m6lj7mhmtz">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17811" data-mp="e88exl2c86d9">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17812" data-mp="s554zkamtjt3" />
                  <span data-id="element-17813" data-mp="s3k83o0uhos2">31,542 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17814" data-mp="o4330vpbytnf">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17815" data-mp="11uewaxxniyg5" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17816" data-mp="wyq094kubzol">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-17817" data-mp="16wdvrwq9tb7t">
            After three decades in endocrinology, I've prescribed thousands of
            medications. But when patients on semaglutide started reporting
            severe depression—and regulatory agencies ignored it—I decided to
            run a 16-month investigation. What I discovered will save you
            sleepless nights - and might actually change your life.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17818" data-mp="2hh1ygyetj1nf">
            <div className="mb-1 flex items-center" data-id="element-17819" data-mp="2rcva8fkpqr45">
              <span className="font-medium mr-2" data-id="element-17820" data-mp="2rbadcjaxew34">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17821" data-mp="2w9lp4zks7gnz">
              <span className="font-medium mr-2" data-id="element-17822" data-mp="6lur81mnjvjt">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-17823" data-mp="1mbvmskui8xme">
        <div className="max-w-4xl mx-auto" data-id="element-17824" data-mp="1he2k41seulqv">
          <div className="sm:flex items-center" data-id="element-17825" data-mp="1cfsmlkj7r923">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-17826" data-mp="1cgk8u4qx7ufp">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham in medical office" className="w-full rounded-lg shadow-md" data-id="element-17827" data-mp="18efef3snets0" />
            </div>
            <div className="sm:w-2/3" data-id="element-17828" data-mp="ygj60jr3icxl">
              <p className="text-sm text-gray-700 mb-2" data-id="element-17829" data-mp="yhkjsvzhxdj0">
                <span className="font-bold" data-id="element-17830" data-mp="2xtn9inypr454">Dr. Tom Parham, MD, FACE</span> is a
                board-certified endocrinologist with 30 years of clinical
                experience specializing in diabetes management and metabolic
                disorders. Throughout his career, he has evaluated hundreds of
                pharmaceutical treatments and their long-term effects on
                patients.
              </p>
              <p className="text-sm text-gray-700" data-id="element-17831" data-mp="h804janqwvkf">
                His investigative work focuses on identifying and solving
                medication side effects that fall through the cracks of official
                approval processes, helping patients achieve health outcomes
                without sacrificing quality of life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpInvestigationC;